module.exports = __webpack_public_path__ + "img/Blumenwiese-1407.f3157dc7.jpg";